export function isBoardUpgraded(availability, selectedBoardType) {
    var _a, _b;
    const baseBoardType = (_b = (_a = availability === null || availability === void 0 ? void 0 : availability.boardOptions) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.boardType;
    return baseBoardType !== selectedBoardType;
}
